// Colours on a black LED screen.

const channel = (v: number) => { const x = v / 255; return x <= 0.04045 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4; };
const luminance = ([r, g, b]: number[]) => 0.2126 * channel(r) + 0.7152 * channel(g) + 0.0722 * channel(b);
const hex = (c: number[]) => `#${c.map(v => Math.round(Math.max(0, Math.min(255, v))).toString(16).padStart(2, '0')).join('')}`;

/**
 * A team colour that reads on black: dark navy becomes a brighter blue, maroon a brighter red.
 * First brighten keeping the hue, then mix towards white, until contrast with black is at least 7:1.
 */
export function readableOnBlack(color: string): string {
  const rgb = [1, 3, 5].map(i => parseInt(color.slice(i, i + 2), 16));
  if (!/^#[0-9a-f]{6}$/i.test(color)) return '#ffffff';
  const ok = (c: number[]) => (luminance(c) + 0.05) / 0.05 >= 7;
  if (ok(rgb)) return color.toLowerCase();
  const peak = Math.max(...rgb, 1);
  for (let k = 1; k <= 255 / peak; k += 0.05) {
    const c = rgb.map(v => v * k);
    if (ok(c)) return hex(c);
  }
  const full = rgb.map(v => (v * 255) / peak);
  for (let t = 0; t <= 1; t += 0.05) {
    const c = full.map(v => v + (255 - v) * t);
    if (ok(c)) return hex(c);
  }
  return '#ffffff';
}
